import styled from 'styled-components';

export default styled.div`
  width: ${({ $size }) => $size.width};
  height: ${({ $size }) => $size.height};
`;
